var path = 'app/portainer/components/status-indicator/status-indicator.html';
var html = "<i aria-hidden=\"true\" ng-class=\"['status-indicator', { ok: $ctrl.ok }]\"></i>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;